export default __webpack_public_path__ + "static/media/Slide7.74a3c108.jpg";